import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Spin } from 'antd';

import { countryDetailLoad } from "store/api/geo_country";
import { DataLoadComponent } from 'components/common';


class CountryValue extends DataLoadComponent {
    apiDetailLoad = countryDetailLoad;

    render() {
        const { id, mode } = this.props;
        const { detail, loadStatus } = this.state;
        const value = (detail && detail.name_en) || id;
        const asLink = mode === 'link';

        return (
            <Spin spinning={loadStatus.isLoading}>
                {asLink ?
                    <Link to={`/country/${id}`}>{value}</Link>
                    :
                    <span>{value}</span>
                }
            </Spin>
        );
    }
}

function mapStateToProps(state) {
    return {
        auth_token: state.auth.token,
    };
}

export default connect(mapStateToProps)(CountryValue);
